import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { SimpleTable } from '../../../../components/SimpleTable';
import { colors } from '../../../../utils/colors';
import {
  getTwoDecimal,
  translateBenchmarkDescription,
} from '../../../../utils/helpers';
import { translation } from '../../../Translation/scorecard';

function PriceMultiples({ portfolio, benchmark, language, pdf }) {
  const french = language === 'fr';
  return (
    <TableWrapper>
      <SimpleTable>
        <thead>
          <tr>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <th />
            <th>{translation[language].PRICEMULTIPLES_TABLE.header1}</th>
            <th>{translation[language].PRICEMULTIPLES_TABLE.header2}</th>
            <th>{translation[language].PRICEMULTIPLES_TABLE.header3}</th>
            <th>{translation[language].PRICEMULTIPLES_TABLE.header4}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{translation[language].PRICEMULTIPLES_TABLE.portfolio}</td>
            <td>{getTwoDecimal(portfolio.price_to_earnings) || '-'}</td>
            <td>{getTwoDecimal(portfolio.price_to_cashflow) || '-'}</td>
            <td>{getTwoDecimal(portfolio.price_to_book) || '-'}</td>
            <td>{getTwoDecimal(portfolio.price_to_sales) || '-'}</td>
          </tr>
          <tr>
            <td>
              {translation[language].PRICEMULTIPLES_TABLE.benchmark}
              {benchmark.desc && pdf ? (
                '*'
              ) : (
                <Popup
                  trigger={
                    <Icon
                      name="question circle outline"
                      style={{
                        fontSize: '15px',
                        verticalAlign: 'initial',
                        color: 'dimgrey',
                      }}
                    />
                  }
                  position="top center"
                  content={translateBenchmarkDescription(
                    benchmark.desc,
                    french
                  )}
                  wide
                />
              )}
            </td>
            <td>{getTwoDecimal(benchmark.price_to_earnings) || '-'}</td>
            <td>{getTwoDecimal(benchmark.price_to_cashflow) || '-'}</td>
            <td>{getTwoDecimal(benchmark.price_to_book) || '-'}</td>
            <td>{getTwoDecimal(benchmark.price_to_sales) || '-'}</td>
          </tr>
        </tbody>
        {pdf && (
          <div style={{ marginTop: '1rem', textAlign: 'left' }}>
            * {translateBenchmarkDescription(benchmark.desc, french)}
          </div>
        )}
      </SimpleTable>
    </TableWrapper>
  );
}

export default connect((state) => ({
  language: state.Storage.language,
}))(PriceMultiples);

PriceMultiples.propTypes = {
  portfolio: PropTypes.object.isRequired,
  benchmark: PropTypes.object.isRequired,
  language: PropTypes.string,
  pdf: PropTypes.bool,
};

PriceMultiples.defaultProps = {
  language: 'en',
  pdf: false,
};

const TableWrapper = styled.div`
  width: 80%;
  table {
    color: black !important;
  }
  thead {
    border-top: 1px solid ${colors.lightGrey};
  }
`;
